interface IconWithTextProps {
  icon: string;
  text: string;
  iconSize?: string;
  iconAlt?: string;
}

const IconWithText = ({ icon, text, iconSize = 'w-5 h-5', iconAlt = '' }: IconWithTextProps) => {
  return (
    <div className="flex gap-2 items-center">
      <img src={icon} alt={iconAlt} className={iconSize} />
      <span className="body-lr-regular text-(--font-body-1)">{text}</span>
    </div>
  );
};

export default IconWithText;

